import { hotTopics } from '@/mocks/gua';

export default function TopicSection() {
  return (
    <section className="w-full bg-background-100/60 py-12 md:py-16">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="flex flex-col gap-1.5">
            <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">瓜田分类</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">按栏目挑你爱吃的瓜</h2>
            <p className="mt-1 max-w-2xl text-sm text-foreground-700">每个栏目都沉淀了大量事件时间线与复盘，按兴趣直达。</p>
          </div>
          <a
            href="#timeline"
            className="inline-flex whitespace-nowrap items-center gap-1 rounded-md bg-secondary-100 px-4 py-2 text-sm text-secondary-900 transition-colors hover:bg-secondary-200"
          >
            去时间线筛选
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div id="topic" className="mt-8 grid scroll-mt-24 grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {hotTopics.map((t) => (
            <article
              key={t.key}
              className="flex items-start gap-4 rounded-lg bg-background-50 p-5 ring-1 ring-background-200 transition-colors hover:bg-background-50 hover:ring-accent-300"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${t.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{t.name}</h3>
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900">{t.count} 条复盘</span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-700">{t.desc}</p>
                <a
                  href="#timeline"
                  className="mt-2 inline-flex whitespace-nowrap items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-600"
                >
                  进入栏目
                  <i className="ri-arrow-right-line text-xs" aria-hidden="true"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}